module.exports = __webpack_public_path__ + "img/white-walls.0babc688.jpg";